import { createContext } from 'react';

import type { PageCard as PageCardData, PageCardState } from './card-types.ts';
import { QuickActionsEnum } from './Items/QuickActions/QuickActionsEnum.ts';

export const PageCardContext = createContext<PageCardData & PageCardState>({
	id: '',
	title: {
		text: '',
		emoji: '',
	},
	type: 'page',
	subType: null,
	status: undefined,
	createdBy: {
		displayName: '',
		profilePicture: '',
		accountId: '',
	},
	ownedBy: {
		displayName: '',
		profilePicture: '',
		accountId: '',
	},
	space: {
		spaceKey: '',
		name: '',
	},
	lastAction: {
		when: '',
		action: 'visited',
	},
	editorVersion: '',
	isStarred: false,
	links: {
		webui: '',
		editui: '',
	},
	history: {
		ownedBy: {
			displayName: '',
		},
	},
	creatorId: '',
	likesCount: 0,
	commentsCount: 0,
	setIsMenuOpen: () => {},
	isMenuOpen: false,
	setSelectedMenuItems: () => {},
	selectedMenuItems: {
		[QuickActionsEnum.WatchButton]: false,
	},
	appearance: 'grid',
	isViewed: false,
	setIsViewed: () => {},
	smallCard: false,
});
